// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__GUjVB","search":"Settings_search__1eZ4J","filter":"Settings_filter__gA6Cz"};